import { render, staticRenderFns } from "./FieldWidget.vue?vue&type=template&id=28229ed9"
import script from "./FieldWidget.vue?vue&type=script&lang=js"
export * from "./FieldWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports